import React from 'react';
import { useIntl } from 'react-intl';
import Html from 'components/html';
import { noDigitsCurrencyFormat } from 'utils/format-number';

import Sparkle from '../assets/sparkle.svg';

import styles from './earnings-ranking.module.scss';

interface EarningsRankingElement {
  ranking: 'gold' | 'silver' | 'bronze';
  rank: number;
  amount: number;
}

const EarningsRanking: React.FunctionComponent<EarningsRankingElement> = (props) => {
  const { ranking, rank, amount } = props;
  const { formatNumber } = useIntl();
  const isGold = ranking === 'gold';

  return (
    <Html.div className="position-relative">
      {isGold && <Sparkle className={styles.sparkle} />}
      <Html.div className={[styles.earningsRanking, styles[ranking], isGold && styles.shiny]}>
        <Html.span className={styles.rankCircle}>
          <Html.span className={styles.rank}>{rank}</Html.span>
        </Html.span>
        <Html.span className={styles.amount}>{formatNumber(amount, noDigitsCurrencyFormat)}</Html.span>
      </Html.div>
    </Html.div>
  );
};

export type { EarningsRankingElement };
export default EarningsRanking;
